module.exports = __webpack_public_path__ + "img/63b6572.svg";